// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: FRemyPrB4r

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import TextInput from "../../TextInput"; // plasmic-import: 5gQXQ5PIHOg/component

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicSearchBar.module.css"; // plasmic-import: FRemyPrB4r/css

import IconsearchIcon from "./icons/PlasmicIcon__Iconsearch"; // plasmic-import: uHwmt7ZDLJO/icon
import SearchsvgIcon from "./icons/PlasmicIcon__Searchsvg"; // plasmic-import: rQjkwIrrF-2/icon
import IconsCloseIcon from "./icons/PlasmicIcon__IconsClose"; // plasmic-import: -dI1oop3LS/icon

createPlasmicElementProxy;

export type PlasmicSearchBar__VariantMembers = {
  variant: "inactive" | "active";
  placeholder:
    | "searchForChannels"
    | "searchForTwitterUsers"
    | "youtubePlaylists"
    | "websites";
};
export type PlasmicSearchBar__VariantsArgs = {
  variant?: SingleChoiceArg<"inactive" | "active">;
  placeholder?: SingleChoiceArg<
    | "searchForChannels"
    | "searchForTwitterUsers"
    | "youtubePlaylists"
    | "websites"
  >;
};
type VariantPropType = keyof PlasmicSearchBar__VariantsArgs;
export const PlasmicSearchBar__VariantProps = new Array<VariantPropType>(
  "variant",
  "placeholder"
);

export type PlasmicSearchBar__ArgsType = {};
type ArgPropType = keyof PlasmicSearchBar__ArgsType;
export const PlasmicSearchBar__ArgProps = new Array<ArgPropType>();

export type PlasmicSearchBar__OverridesType = {
  root?: p.Flex<"div">;
  darkActive?: p.Flex<"div">;
  searchInput?: p.Flex<typeof TextInput>;
};

export interface DefaultSearchBarProps {
  variant?: SingleChoiceArg<"inactive" | "active">;
  placeholder?: SingleChoiceArg<
    | "searchForChannels"
    | "searchForTwitterUsers"
    | "youtubePlaylists"
    | "websites"
  >;
  className?: string;
}

const $$ = {};

function PlasmicSearchBar__RenderFunc(props: {
  variants: PlasmicSearchBar__VariantsArgs;
  args: PlasmicSearchBar__ArgsType;
  overrides: PlasmicSearchBar__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "variant",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.variant
      },
      {
        path: "placeholder",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.placeholder
      },
      {
        path: "searchInput.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [sty.rootvariant_inactive]: hasVariant($state, "variant", "inactive")
        }
      )}
    >
      <p.Stack
        as={"div"}
        data-plasmic-name={"darkActive"}
        data-plasmic-override={overrides.darkActive}
        hasGap={true}
        className={classNames(projectcss.all, sty.darkActive, {
          [sty.darkActivevariant_inactive]: hasVariant(
            $state,
            "variant",
            "inactive"
          )
        })}
      >
        <IconsearchIcon
          className={classNames(projectcss.all, sty.svg__li5Um, {
            [sty.svgvariant_active__li5UmIuyoo]: hasVariant(
              $state,
              "variant",
              "active"
            ),
            [sty.svgvariant_inactive__li5UmZ3Azc]: hasVariant(
              $state,
              "variant",
              "inactive"
            )
          })}
          role={"img"}
        />

        <TextInput
          data-plasmic-name={"searchInput"}
          data-plasmic-override={overrides.searchInput}
          className={classNames("__wab_instance", sty.searchInput, {
            [sty.searchInputplaceholder_searchForChannels]: hasVariant(
              $state,
              "placeholder",
              "searchForChannels"
            ),
            [sty.searchInputplaceholder_searchForTwitterUsers]: hasVariant(
              $state,
              "placeholder",
              "searchForTwitterUsers"
            ),
            [sty.searchInputplaceholder_websites]: hasVariant(
              $state,
              "placeholder",
              "websites"
            ),
            [sty.searchInputplaceholder_youtubePlaylists]: hasVariant(
              $state,
              "placeholder",
              "youtubePlaylists"
            ),
            [sty.searchInputvariant_inactive]: hasVariant(
              $state,
              "variant",
              "inactive"
            )
          })}
          color={
            hasVariant($state, "variant", "inactive") ? "white" : undefined
          }
          context={"searchBar"}
          onChange={(...eventArgs) => {
            p.generateStateOnChangeProp($state, ["searchInput", "value"])(
              (e => e.target?.value).apply(null, eventArgs)
            );
          }}
          placeholder={
            hasVariant($state, "placeholder", "websites")
              ? "enter a website.com or a rss link"
              : hasVariant($state, "placeholder", "youtubePlaylists")
              ? "paste a link with a playlist id or search for playlists by name"
              : hasVariant($state, "placeholder", "searchForTwitterUsers")
              ? "search for Twitter users"
              : hasVariant($state, "placeholder", "searchForChannels")
              ? "search for channels"
              : undefined
          }
          showEndIcon={true}
          showStartIcon={true}
          value={
            p.generateStateValueProp($state, ["searchInput", "value"]) ?? ""
          }
        />

        <IconsCloseIcon
          className={classNames(projectcss.all, sty.svg__xvzpU)}
          role={"img"}
        />
      </p.Stack>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "darkActive", "searchInput"],
  darkActive: ["darkActive", "searchInput"],
  searchInput: ["searchInput"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  darkActive: "div";
  searchInput: typeof TextInput;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicSearchBar__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicSearchBar__VariantsArgs;
    args?: PlasmicSearchBar__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicSearchBar__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicSearchBar__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSearchBar__ArgProps,
          internalVariantPropNames: PlasmicSearchBar__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSearchBar__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSearchBar";
  } else {
    func.displayName = `PlasmicSearchBar.${nodeName}`;
  }
  return func;
}

export const PlasmicSearchBar = Object.assign(
  // Top-level PlasmicSearchBar renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    darkActive: makeNodeComponent("darkActive"),
    searchInput: makeNodeComponent("searchInput"),

    // Metadata about props expected for PlasmicSearchBar
    internalVariantProps: PlasmicSearchBar__VariantProps,
    internalArgProps: PlasmicSearchBar__ArgProps
  }
);

export default PlasmicSearchBar;
/* prettier-ignore-end */
